module.exports = __webpack_public_path__ + "static/media/host.5d628f0c.png";